import Vue from 'vue'
import Vuex from 'vuex'
import Meta from 'vue-meta'
import ClientOnly from 'vue-client-only'
import NoSsr from 'vue-no-ssr'
import { createRouter } from './router.js'
import NuxtChild from './components/nuxt-child.js'
import NuxtError from '../layouts/error.vue'
import Nuxt from './components/nuxt.js'
import App from './App.js'
import { setContext, getLocation, getRouteData, normalizeError } from './utils'
import { createStore } from './store.js'

/* Plugins */

import nuxt_plugin_sentryserver_3c2a1cda from 'nuxt_plugin_sentryserver_3c2a1cda' // Source: ./sentry.server.js (mode: 'server')
import nuxt_plugin_sentryclient_531ea95c from 'nuxt_plugin_sentryclient_531ea95c' // Source: ./sentry.client.js (mode: 'client')
import nuxt_plugin_toast_598a1fc5 from 'nuxt_plugin_toast_598a1fc5' // Source: ./toast.js (mode: 'client')
import nuxt_plugin_cookieuniversalnuxt_20e686be from 'nuxt_plugin_cookieuniversalnuxt_20e686be' // Source: ./cookie-universal-nuxt.js (mode: 'all')
import nuxt_plugin_pluginclient_4769737c from 'nuxt_plugin_pluginclient_4769737c' // Source: ./content/plugin.client.js (mode: 'client')
import nuxt_plugin_pluginserver_a5ba35f8 from 'nuxt_plugin_pluginserver_a5ba35f8' // Source: ./content/plugin.server.js (mode: 'server')
import nuxt_plugin_image_7860d011 from 'nuxt_plugin_image_7860d011' // Source: ./image.js (mode: 'all')
import nuxt_plugin_nuxtsvgsprite_23e96a98 from 'nuxt_plugin_nuxtsvgsprite_23e96a98' // Source: ./nuxt-svg-sprite.js (mode: 'all')
import nuxt_plugin_axios_e54c59d4 from 'nuxt_plugin_axios_e54c59d4' // Source: ./axios.js (mode: 'all')
import nuxt_plugin_apollomodule_65fb28e2 from 'nuxt_plugin_apollomodule_65fb28e2' // Source: ./apollo-module.js (mode: 'all')
import nuxt_plugin_deviceplugin_5e4ff4a1 from 'nuxt_plugin_deviceplugin_5e4ff4a1' // Source: ./device.plugin.js (mode: 'all')
import nuxt_plugin_axios_3566aa80 from 'nuxt_plugin_axios_3566aa80' // Source: ../plugins/axios (mode: 'all')
import nuxt_plugin_oruga_33e134d4 from 'nuxt_plugin_oruga_33e134d4' // Source: ../plugins/oruga (mode: 'all')
import nuxt_plugin_vuedompurifyhtml_30310875 from 'nuxt_plugin_vuedompurifyhtml_30310875' // Source: ../plugins/vue-dompurify-html.client (mode: 'client')
import nuxt_plugin_utilities_944fbf58 from 'nuxt_plugin_utilities_944fbf58' // Source: ../plugins/utilities (mode: 'all')
import nuxt_plugin_clickoutside_2bc8eaac from 'nuxt_plugin_clickoutside_2bc8eaac' // Source: ../plugins/click-outside (mode: 'all')
import nuxt_plugin_veevalidate_6e5ad03a from 'nuxt_plugin_veevalidate_6e5ad03a' // Source: ../plugins/vee-validate (mode: 'all')
import nuxt_plugin_filters_98405076 from 'nuxt_plugin_filters_98405076' // Source: ../plugins/filters (mode: 'all')
import nuxt_plugin_scrollbar_ee8f2120 from 'nuxt_plugin_scrollbar_ee8f2120' // Source: ../plugins/scrollbar (mode: 'all')
import nuxt_plugin_interactionsPersistedState_245d0604 from 'nuxt_plugin_interactionsPersistedState_245d0604' // Source: ../plugins/interactionsPersistedState.client (mode: 'client')
import nuxt_plugin_searchesPersistedState_e4874b22 from 'nuxt_plugin_searchesPersistedState_e4874b22' // Source: ../plugins/searchesPersistedState.client (mode: 'client')
import nuxt_plugin_propertiesPersistedState_948fb19c from 'nuxt_plugin_propertiesPersistedState_948fb19c' // Source: ../plugins/propertiesPersistedState.client (mode: 'client')
import nuxt_plugin_svg4everybody_1cabf662 from 'nuxt_plugin_svg4everybody_1cabf662' // Source: ../plugins/svg4everybody.client (mode: 'client')
import nuxt_plugin_googlemaps_0decd138 from 'nuxt_plugin_googlemaps_0decd138' // Source: ../plugins/google-maps.client (mode: 'client')
import nuxt_plugin_swiperclient_d2033868 from 'nuxt_plugin_swiperclient_d2033868' // Source: ../plugins/swiper.client.js (mode: 'client')
import nuxt_plugin_auth_42181b5a from 'nuxt_plugin_auth_42181b5a' // Source: ./auth.js (mode: 'all')
import nuxt_plugin_authutilities_08a6bafe from 'nuxt_plugin_authutilities_08a6bafe' // Source: ../plugins/auth-utilities.client (mode: 'client')
import nuxt_plugin_tealium_03a2a9ea from 'nuxt_plugin_tealium_03a2a9ea' // Source: ../plugins/tealium.client (mode: 'client')
import nuxt_plugin_auth_6442cd9b from 'nuxt_plugin_auth_6442cd9b' // Source: ../plugins/auth.client (mode: 'client')
import nuxt_plugin_interactions_9ab99afc from 'nuxt_plugin_interactions_9ab99afc' // Source: ../plugins/interactions.client (mode: 'client')
import nuxt_plugin_installapp_e6374cc0 from 'nuxt_plugin_installapp_e6374cc0' // Source: ../plugins/install-app.client (mode: 'client')

// Component: <ClientOnly>
Vue.component(ClientOnly.name, ClientOnly)

// TODO: Remove in Nuxt 3: <NoSsr>
Vue.component(NoSsr.name, {
  ...NoSsr,
  render (h, ctx) {
    if (process.client && !NoSsr._warned) {
      NoSsr._warned = true

      console.warn('<no-ssr> has been deprecated and will be removed in Nuxt 3, please use <client-only> instead')
    }
    return NoSsr.render(h, ctx)
  }
})

// Component: <NuxtChild>
Vue.component(NuxtChild.name, NuxtChild)
Vue.component('NChild', NuxtChild)

// Component NuxtLink is imported in server.js or client.js

// Component: <Nuxt>
Vue.component(Nuxt.name, Nuxt)

Object.defineProperty(Vue.prototype, '$nuxt', {
  get() {
    const globalNuxt = this.$root ? this.$root.$options.$nuxt : null
    if (process.client && !globalNuxt && typeof window !== 'undefined') {
      return window.$nuxt
    }
    return globalNuxt
  },
  configurable: true
})

Vue.use(Meta, {"keyName":"head","attribute":"data-n-head","ssrAttribute":"data-n-head-ssr","tagIDKeyName":"hid"})

const defaultTransition = {"name":"page","mode":"out-in","appear":false,"appearClass":"appear","appearActiveClass":"appear-active","appearToClass":"appear-to"}

const originalRegisterModule = Vuex.Store.prototype.registerModule

function registerModule (path, rawModule, options = {}) {
  const preserveState = process.client && (
    Array.isArray(path)
      ? !!path.reduce((namespacedState, path) => namespacedState && namespacedState[path], this.state)
      : path in this.state
  )
  return originalRegisterModule.call(this, path, rawModule, { preserveState, ...options })
}

async function createApp(ssrContext, config = {}) {
  const store = createStore(ssrContext)
  const router = await createRouter(ssrContext, config, { store })

  // Add this.$router into store actions/mutations
  store.$router = router

  // Fix SSR caveat https://github.com/nuxt/nuxt.js/issues/3757#issuecomment-414689141
  store.registerModule = registerModule

  // Create Root instance

  // here we inject the router and store to all child components,
  // making them available everywhere as `this.$router` and `this.$store`.
  const app = {
    head: {"htmlAttrs":{"lang":"it"},"title":"UniCredit RE Services: Annunci immobiliari e Vendita Case","meta":[{"charset":"utf-8"},{"http-equiv":"X-UA-Compatible","content":"IE=edge"},{"name":"viewport","content":"width=device-width, initial-scale=1, minimum-scale=1"},{"name":"theme-color","content":"#e2001a"},{"hid":"description","name":"description","content":"Per comprare o vendere la tua casa affidati a UniCredit RE Services: semplicità, trasparenza e professionalità in ogni fase della compravendita."},{"name":"mobile-web-app-capable","content":"yes"},{"hid":"google-site-verification","name":"google-site-verification","content":"pLlcoQRqymn5zEa6FwxDwk8ow9znuKO3LqwIaVmFh30"},{"hid":"robots","name":"robots","content":"index,follow"}],"link":[{"rel":"shortcut icon","href":"\u002Ffavicon.ico"},{"rel":"apple-touch-icon-precomposed","sizes":"144x144","href":"\u002Fassets\u002Fimg\u002Ffavicons\u002Fapple-touch-icon-144x144.png"},{"rel":"apple-touch-icon-precomposed","sizes":"114x114","href":"\u002Fassets\u002Fimg\u002Ffavicons\u002Fapple-touch-icon-114x114.png"},{"rel":"apple-touch-icon-precomposed","sizes":"72x72","href":"\u002Fassets\u002Fimg\u002Ffavicons\u002Fapple-touch-icon-72x72.png"},{"rel":"apple-touch-icon-precomposed","sizes":"57x57","href":"\u002Fassets\u002Fimg\u002Ffavicons\u002Fapple-touch-icon-57x57.png"},{"rel":"apple-touch-icon-precomposed","sizes":"57x57","href":"\u002Fassets\u002Fimg\u002Ffavicons\u002Fapple-touch-icon-57x57-precomposed.png"},{"rel":"apple-touch-icon-precomposed","sizes":"60x60","href":"\u002Fassets\u002Fimg\u002Ffavicons\u002Fapple-touch-icon-60x60.png"},{"rel":"apple-touch-icon-precomposed","sizes":"120x120","href":"\u002Fassets\u002Fimg\u002Ffavicons\u002Fapple-touch-icon-120x120.png"},{"rel":"apple-touch-icon-precomposed","sizes":"76x76","href":"\u002Fassets\u002Fimg\u002Ffavicons\u002Fapple-touch-icon-76x76.png"},{"rel":"apple-touch-icon-precomposed","sizes":"152x152","href":"\u002Fassets\u002Fimg\u002Ffavicons\u002Fapple-touch-icon-152x152.png"},{"rel":"apple-touch-icon-precomposed","sizes":"180x180","href":"\u002Fassets\u002Fimg\u002Ffavicons\u002Fapple-touch-icon-180x180.png"},{"rel":"apple-touch-icon-precomposed","sizes":"192x192","href":"\u002Fassets\u002Fimg\u002Ffavicons\u002Fapple-touch-icon-192x192.png"},{"rel":"apple-touch-icon-precomposed","sizes":"512x512","href":"\u002Fassets\u002Fimg\u002Ffavicons\u002Fapple-touch-icon-512x512.png"},{"rel":"apple-touch-icon-precomposed","href":"\u002Fassets\u002Fimg\u002Ffavicons\u002Fapple-touch-icon.png"},{"rel":"apple-touch-icon-precomposed","href":"\u002Fassets\u002Fimg\u002Ffavicons\u002Fapple-touch-icon-precomposed.png"},{"rel":"manifest","href":"\u002Fmanifest.json","crossorigin":"use-credentials"},{"rel":"preconnect","href":"http:\u002F\u002Ftags.tiqcdn.com"},{"rel":"preconnect","href":"https:\u002F\u002Fajax.googleapis.com"}],"script":[{"src":"https:\u002F\u002Fwww.unicreditres.it\u002Futag\u002Fmain\u002Fprod\u002Futag.js","type":"text\u002Fjavascript","async":true,"body":true},{"src":"https:\u002F\u002Fwww.unicreditres.it\u002Futag\u002Fmain\u002Fprod\u002Futag.sync.js","type":"text\u002Fjavascript","async":true,"body":true}],"style":[]},

    store,
    router,
    nuxt: {
      defaultTransition,
      transitions: [defaultTransition],
      setTransitions (transitions) {
        if (!Array.isArray(transitions)) {
          transitions = [transitions]
        }
        transitions = transitions.map((transition) => {
          if (!transition) {
            transition = defaultTransition
          } else if (typeof transition === 'string') {
            transition = Object.assign({}, defaultTransition, { name: transition })
          } else {
            transition = Object.assign({}, defaultTransition, transition)
          }
          return transition
        })
        this.$options.nuxt.transitions = transitions
        return transitions
      },

      err: null,
      dateErr: null,
      error (err) {
        err = err || null
        app.context._errored = Boolean(err)
        err = err ? normalizeError(err) : null
        let nuxt = app.nuxt // to work with @vue/composition-api, see https://github.com/nuxt/nuxt.js/issues/6517#issuecomment-573280207
        if (this) {
          nuxt = this.nuxt || this.$options.nuxt
        }
        nuxt.dateErr = Date.now()
        nuxt.err = err
        // Used in src/server.js
        if (ssrContext) {
          ssrContext.nuxt.error = err
        }
        return err
      }
    },
    ...App
  }

  // Make app available into store via this.app
  store.app = app

  const next = ssrContext ? ssrContext.next : location => app.router.push(location)
  // Resolve route
  let route
  if (ssrContext) {
    route = router.resolve(ssrContext.url).route
  } else {
    const path = getLocation(router.options.base, router.options.mode)
    route = router.resolve(path).route
  }

  // Set context to app.context
  await setContext(app, {
    store,
    route,
    next,
    error: app.nuxt.error.bind(app),
    payload: ssrContext ? ssrContext.payload : undefined,
    req: ssrContext ? ssrContext.req : undefined,
    res: ssrContext ? ssrContext.res : undefined,
    beforeRenderFns: ssrContext ? ssrContext.beforeRenderFns : undefined,
    beforeSerializeFns: ssrContext ? ssrContext.beforeSerializeFns : undefined,
    ssrContext
  })

  function inject(key, value) {
    if (!key) {
      throw new Error('inject(key, value) has no key provided')
    }
    if (value === undefined) {
      throw new Error(`inject('${key}', value) has no value provided`)
    }

    key = '$' + key
    // Add into app
    app[key] = value
    // Add into context
    if (!app.context[key]) {
      app.context[key] = value
    }

    // Add into store
    store[key] = app[key]

    // Check if plugin not already installed
    const installKey = '__nuxt_' + key + '_installed__'
    if (Vue[installKey]) {
      return
    }
    Vue[installKey] = true
    // Call Vue.use() to install the plugin into vm
    Vue.use(() => {
      if (!Object.prototype.hasOwnProperty.call(Vue.prototype, key)) {
        Object.defineProperty(Vue.prototype, key, {
          get () {
            return this.$root.$options[key]
          }
        })
      }
    })
  }

  // Inject runtime config as $config
  inject('config', config)

  if (process.client) {
    // Replace store state before plugins execution
    if (window.__NUXT__ && window.__NUXT__.state) {
      store.replaceState(window.__NUXT__.state)
    }
  }

  // Add enablePreview(previewData = {}) in context for plugins
  if (process.static && process.client) {
    app.context.enablePreview = function (previewData = {}) {
      app.previewData = Object.assign({}, previewData)
      inject('preview', previewData)
    }
  }
  // Plugin execution

  if (process.server && typeof nuxt_plugin_sentryserver_3c2a1cda === 'function') {
    await nuxt_plugin_sentryserver_3c2a1cda(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_sentryclient_531ea95c === 'function') {
    await nuxt_plugin_sentryclient_531ea95c(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_toast_598a1fc5 === 'function') {
    await nuxt_plugin_toast_598a1fc5(app.context, inject)
  }

  if (typeof nuxt_plugin_cookieuniversalnuxt_20e686be === 'function') {
    await nuxt_plugin_cookieuniversalnuxt_20e686be(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_pluginclient_4769737c === 'function') {
    await nuxt_plugin_pluginclient_4769737c(app.context, inject)
  }

  if (process.server && typeof nuxt_plugin_pluginserver_a5ba35f8 === 'function') {
    await nuxt_plugin_pluginserver_a5ba35f8(app.context, inject)
  }

  if (typeof nuxt_plugin_image_7860d011 === 'function') {
    await nuxt_plugin_image_7860d011(app.context, inject)
  }

  if (typeof nuxt_plugin_nuxtsvgsprite_23e96a98 === 'function') {
    await nuxt_plugin_nuxtsvgsprite_23e96a98(app.context, inject)
  }

  if (typeof nuxt_plugin_axios_e54c59d4 === 'function') {
    await nuxt_plugin_axios_e54c59d4(app.context, inject)
  }

  if (typeof nuxt_plugin_apollomodule_65fb28e2 === 'function') {
    await nuxt_plugin_apollomodule_65fb28e2(app.context, inject)
  }

  if (typeof nuxt_plugin_deviceplugin_5e4ff4a1 === 'function') {
    await nuxt_plugin_deviceplugin_5e4ff4a1(app.context, inject)
  }

  if (typeof nuxt_plugin_axios_3566aa80 === 'function') {
    await nuxt_plugin_axios_3566aa80(app.context, inject)
  }

  if (typeof nuxt_plugin_oruga_33e134d4 === 'function') {
    await nuxt_plugin_oruga_33e134d4(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_vuedompurifyhtml_30310875 === 'function') {
    await nuxt_plugin_vuedompurifyhtml_30310875(app.context, inject)
  }

  if (typeof nuxt_plugin_utilities_944fbf58 === 'function') {
    await nuxt_plugin_utilities_944fbf58(app.context, inject)
  }

  if (typeof nuxt_plugin_clickoutside_2bc8eaac === 'function') {
    await nuxt_plugin_clickoutside_2bc8eaac(app.context, inject)
  }

  if (typeof nuxt_plugin_veevalidate_6e5ad03a === 'function') {
    await nuxt_plugin_veevalidate_6e5ad03a(app.context, inject)
  }

  if (typeof nuxt_plugin_filters_98405076 === 'function') {
    await nuxt_plugin_filters_98405076(app.context, inject)
  }

  if (typeof nuxt_plugin_scrollbar_ee8f2120 === 'function') {
    await nuxt_plugin_scrollbar_ee8f2120(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_interactionsPersistedState_245d0604 === 'function') {
    await nuxt_plugin_interactionsPersistedState_245d0604(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_searchesPersistedState_e4874b22 === 'function') {
    await nuxt_plugin_searchesPersistedState_e4874b22(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_propertiesPersistedState_948fb19c === 'function') {
    await nuxt_plugin_propertiesPersistedState_948fb19c(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_svg4everybody_1cabf662 === 'function') {
    await nuxt_plugin_svg4everybody_1cabf662(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_googlemaps_0decd138 === 'function') {
    await nuxt_plugin_googlemaps_0decd138(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_swiperclient_d2033868 === 'function') {
    await nuxt_plugin_swiperclient_d2033868(app.context, inject)
  }

  if (typeof nuxt_plugin_auth_42181b5a === 'function') {
    await nuxt_plugin_auth_42181b5a(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_authutilities_08a6bafe === 'function') {
    await nuxt_plugin_authutilities_08a6bafe(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_tealium_03a2a9ea === 'function') {
    await nuxt_plugin_tealium_03a2a9ea(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_auth_6442cd9b === 'function') {
    await nuxt_plugin_auth_6442cd9b(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_interactions_9ab99afc === 'function') {
    await nuxt_plugin_interactions_9ab99afc(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_installapp_e6374cc0 === 'function') {
    await nuxt_plugin_installapp_e6374cc0(app.context, inject)
  }

  // Lock enablePreview in context
  if (process.static && process.client) {
    app.context.enablePreview = function () {
      console.warn('You cannot call enablePreview() outside a plugin.')
    }
  }

  // Wait for async component to be resolved first
  await new Promise((resolve, reject) => {
    // Ignore 404s rather than blindly replacing URL in browser
    if (process.client) {
      const { route } = router.resolve(app.context.route.fullPath)
      if (!route.matched.length) {
        return resolve()
      }
    }
    router.replace(app.context.route.fullPath, resolve, (err) => {
      // https://github.com/vuejs/vue-router/blob/v3.4.3/src/util/errors.js
      if (!err._isRouter) return reject(err)
      if (err.type !== 2 /* NavigationFailureType.redirected */) return resolve()

      // navigated to a different route in router guard
      const unregister = router.afterEach(async (to, from) => {
        if (process.server && ssrContext && ssrContext.url) {
          ssrContext.url = to.fullPath
        }
        app.context.route = await getRouteData(to)
        app.context.params = to.params || {}
        app.context.query = to.query || {}
        unregister()
        resolve()
      })
    })
  })

  return {
    store,
    app,
    router
  }
}

export { createApp, NuxtError }
